import { Component, inject, PLATFORM_ID } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { IAddressJSON, INearStores } from '@models/store.model';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { GeocodingService } from 'src/app/services/geocoding.service';
import { StoreService } from 'src/app/services/stores.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DecimalPipe, isPlatformBrowser } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-cp-invite-mode-modal',
  templateUrl: './cp-invite-mode-modal.component.html',
  styleUrls: ['./cp-invite-mode-modal.component.scss'],
  standalone: true,
  imports: [LottieComponent, MatFormFieldModule, MatIconModule, MatDialogModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatProgressSpinnerModule, MatRippleModule, DecimalPipe, TranslateModule, NgxMaskDirective]
})
export class CpInviteModeModalComponent {

  public storesLoading = false;
  public step = 0;
  public zipCodeForm = new FormControl<string>(JSON.parse(localStorage.getItem('address') || '{}').zipCode, [Validators.required]);
  public nearStores: INearStores[] = [];
  public tempAddressStore: IAddressJSON = {
    displayName: '',
    type: 'pickup',
    store: 0,
    zipCode: ''
  };
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  public loadingText = 'Buscando sucursales';

  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    private dialogRef: MatDialogRef<CpInviteModeModalComponent>,
    private geocodingService: GeocodingService,
    private storeServices: StoreService,
  ) { }

  public async getStoresByCoords(): Promise<void> {
    this.storesLoading = true;
    this.nearStores = [];
    try {
      const { results } = await this.geocodingService.geocoding(`Mexico, ${this.zipCodeForm.value}`);
      const lat = results[0].geometry.location.lat;
      const lng = results[0].geometry.location.lng;
      const { data } = await this.storeServices.getNearPickupStores(lat, lng);
      this.nearStores = data;
      this.goStep(1);
      this.storesLoading = false;
    } catch (error) {
      this.nearStores = [];
      this.goStep(1);
      this.storesLoading = false;
    }
  }

  public goStep(step: number): void {
    this.step = step;
  }

  public setDefaultAddress(store: INearStores) {
    const addressJSON: IAddressJSON = {
      type: 'pickup',
      displayName: store.name,
      store: store.branch_id,
      zipCode: this.zipCodeForm.value ?? ''
    };
    this.tempAddressStore = addressJSON;
  }

  public onSettingAddress(): void {
    if (this.isBrowser) localStorage.setItem('address', JSON.stringify(this.tempAddressStore));
    this.dialogRef.close({ status: true, pickup: true });
  }
}
